/**
 * Maps PaymentMethodDropdown option id to obligation catalog key.
 * Mirrors reconcileDocumentSideBar / document detail abono flows.
 */
export function getObligationTypeForPaymentMethod(methodId, isReceived = true) {
  switch (methodId) {
    case "efectivo":
      return "pagoenefectivo";
    case "tarjeta_credito":
      return "tarjetadecreditonacional";
    case "cheque":
      return isReceived ? "chequeporpagar" : "chequeporcobrar";
    case "tercero":
      return "pagoporuntercero";
    case "factoring":
      return "ingresoporfactoring";
    case "pasarela_pago":
      return isReceived ? "comisionpasareladepago" : "ingresoporpasarelasdepago";
    case "diferencia_tipo_cambio":
      return "diferenciadetipodecambio";
    default:
      return null;
  }
}

export function buildAbonoInitialDataFromCobranzaDoc(doc, row) {
  if (!doc?.id) return null;
  const issuerName = doc.issuerName || row?.issuerName || "";
  const issuerRut = doc.issuerRut || row?.issuerRut || "";
  const documentId = doc.documentId || doc.folio;
  const remaining = Number(doc.remaining || 0);
  const documentType = doc.documentType || doc.meta?.documentType || "TAX_DOCUMENT";

  return {
    id: doc.id,
    documentId,
    folio: doc.folio || documentId,
    documentType,
    documentDate: doc.documentDate,
    dueDate: doc.dueDate || doc.originalDueDate,
    date: doc.documentDate,
    remaining,
    currencyType: "CLP",
    currency: "CLP",
    issuerName,
    issuerRut,
    agendaId: row?.agenda?.id,
    meta: {
      // Facturas de cobranza: emitidas por la empresa (por cobrar)
      isReceived: false,
      remaining,
      issuerName,
      issuerRut,
      receiverId: issuerRut,
      receiverName: issuerName,
      documentId,
      documentCode: doc.documentCode,
      summary: doc.summary,
      typeLabel: doc.typeLabel,
      documentType,
    },
  };
}
